"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAppBarProfileArrowIcon = exports.StyledAppBarProfileTitle = exports.StyledAppBarProfileRole = exports.StyledAppBarProfileInfo = exports.StyledAppBarProfile = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const ArrowIcon_1 = require("../../../ArrowIcon");
const helpers_1 = require("../../../helpers");
exports.StyledAppBarProfile = styled_components_1.default.div `
    flex-shrink: 0; /* if parent is flexbox-container */
    box-sizing: border-box;
    display: inline-flex;
    padding: ${helpers_1.SPACING_S} ${helpers_1.SPACING_M};
    font: ${helpers_1.BASE_FONT};
    color: ${({ theme }) => theme.colorLinkHeader};
    background-color: ${({ theme }) => theme.colorBackgroundHeader};
    cursor: pointer;

    ${({ isActive, theme }) => {
    if (isActive) {
        return (0, styled_components_1.css) `
                background-color: ${theme.colorHeaderTabActive};
            `;
    }
    return (0, styled_components_1.css) `
            &:hover {
                background-color: ${theme.colorHeaderTabHover};
            }
        `;
}}
`;
exports.StyledAppBarProfileInfo = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: ${helpers_1.SPACING_S};
`;
exports.StyledAppBarProfileRole = styled_components_1.default.div `
    font-family: ${helpers_1.BASE_FONT_FAMILY};
    font-size: ${helpers_1.FONT_SIZE_S};
    line-height: ${helpers_1.FONT_LINE_HEIGHT_S};
    opacity: 0.5;
`;
exports.StyledAppBarProfileTitle = styled_components_1.default.div `
    font: ${helpers_1.BASE_FONT};
`;
exports.StyledAppBarProfileArrowIcon = (0, styled_components_1.default)(ArrowIcon_1.ArrowIcon) `
    fill: ${({ theme }) => theme.colorTextHeader};
`;
//# sourceMappingURL=AppBarProfile.styles.js.map